// extracted by mini-css-extract-plugin
export default {"link":"arrowBack-module--link--1RC-k"};